/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ metric: NonNullable<unknown> }} Ui_Learn_AboutInputs */

const en_ui_learn_about = /** @type {(inputs: Ui_Learn_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Learn about ${i?.metric}`)
};

const de_ui_learn_about = /** @type {(inputs: Ui_Learn_AboutInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mehr über ${i?.metric} erfahren`)
};

/**
* | output |
* | --- |
* | "Learn about {metric}" |
*
* @param {Ui_Learn_AboutInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_learn_about = /** @type {((inputs: Ui_Learn_AboutInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Learn_AboutInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_learn_about(inputs)
	return de_ui_learn_about(inputs)
});